import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {CreditUnion} from "@app/pages/admin/admin.component";
import {CreditUnionService} from "@app/services/credit-union/credit-union.service";
import {HttpClient} from "@angular/common/http";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";

@Component({
    selector: 'flex-account-request',
    templateUrl: './account-request.component.html',
    styleUrls: ['./account-request.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class AccountRequestComponent implements OnInit {
    accountRequest = new AccountRequest;
    creditUnions: BehaviorSubject<CreditUnion[]> = new BehaviorSubject<CreditUnion[]>([]);
    snackConfig: MatSnackBarConfig = {horizontalPosition: "center", verticalPosition: "top", duration: 5000}

    constructor(public creditUnionService: CreditUnionService, private http: HttpClient, private message: MatSnackBar) {
    }

    ngOnInit(): void {
        this.creditUnionService.getAllCreditUnions().subscribe((creditUnions: CreditUnion[]) => this.creditUnions.next(creditUnions))
    }

    requestAccount() {
        if (this.accountRequest.email === '' || this.accountRequest.cuid === '') {
            this.message.open('Invalid request, please provide all of the information and resubmit', 'X', this.snackConfig)
        } else {
            this.submitRequest()
            this.message.open('Request sent! Please allow up to 48 hours for your request to be processed.', 'X', this.snackConfig)
        }
    }

    submitRequest(){
        this.http.post(`/api/unsecured/creditUnion/requestAccount`, {
            cuid: this.accountRequest.cuid,
            fName: this.accountRequest.firstName,
            lName: this.accountRequest.lastName,
            phone: this.accountRequest.phoneNumber,
            email: this.accountRequest.email,
            title: this.accountRequest.jobTitle
        }).subscribe()
    }
}
export class AccountRequest {
    firstName = '';
    lastName = '';
    cuid = '';
    jobTitle = '';
    phoneNumber = '';
    email = '';
}
